import { render } from "./indexFooterdark.vue?vue&type=template&id=7fce7175"
import script from "./indexFooterdark.vue?vue&type=script&lang=js"
export * from "./indexFooterdark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__